import React from 'react';
import { cn } from '@/lib/utils';

const SocialProof = () => {
  return (
    <section id="reviews" className="section-padding bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-12 reveal">
          <h2 className="text-3xl md:text-4xl font-bold text-beauty-rose mb-4">What Our Clients Say</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our satisfied clients have to say about their experience with us.
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          {/* Google Reviews */}
          <div className="reveal">
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h3 className="text-2xl font-playfair font-bold mb-6">Google Reviews</h3>
              <div className="space-y-6">
                {/* Static Review 1 */}
                <div className="border-b border-gray-100 pb-4">
                  <div className="flex items-center mb-2">
                    <div className="flex text-yellow-400 mr-2">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                    <span className="font-medium">Dhruti Kothari</span>
                  </div>
                  <p className="text-gray-600 italic">"Anjana Beauty Care is the best place to do your makeover.
All beauty solutions at one stop.
Alka Aunty who owns this beauty parlour is very expert beautician.
She is very sweet, helpful, quick, punctual and perfectly professional.
Makeup done by her is very superb, natural and is noticed + complimented always by others.
She and her team takes care of all your need and that too with nominal charges.
I really felt she follows "beauty is her duty".
She styles and spread smiles!
She gives the  most fantastic haircut cut and style.
One can always depend on this salon to look fabulous!
Thankyou Aunty for always  being there for me!
I wish you all the best and you keep shining like a pearl. Lots of Love!"</p>
                </div>
                
                {/* Static Review 2 */}
                <div className="border-b border-gray-100 pb-4">
                  <div className="flex items-center mb-2">
                    <div className="flex text-yellow-400 mr-2">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                    <span className="font-medium">Jyoti Sodhi</span>
                  </div>
                  <p className="text-gray-600 italic">"The best parlour in Vadodara I ever visited. Had a wonderful time with the staff and Alka ma'am. The staff was really professional and sweet. Alka ma'am indeed was too good and polite. Loved their services. Will recommend to everyone out there."</p>
                </div>
                
                {/* Static Review 3 */}
                <div>
                  <div className="flex items-center mb-2">
                    <div className="flex text-yellow-400 mr-2">
                      {[...Array(5)].map((_, i) => (
                        <svg key={i} xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                      ))}
                    </div>
                    <span className="font-medium">Himani Verma</span>
                  </div>
                  <p className="text-gray-600 italic">"Visited Anjana Beauty Care first time with my sister who is already a fan of this place. Owner is really particular about the products used for individual service according to skin type and it really got a beautiful effect.  Loved the service and overall friendliness if each and everyone there..  Must visit place for complete satisfaction!!"</p>
                </div>
              </div>
              
              <div className="mt-6 text-center">
                <a 
                  href="https://www.google.com/maps/place/Anjana+Beauty+Care/@22.2679331,73.1882056,17z/data=!4m18!1m9!3m8!1s0x395fc5dbd5bffceb:0x44c6621103b1075a!2sAnjana+Beauty+Care!8m2!3d22.2679331!4d73.1882056!9m1!1b1!16s%2Fg%2F11g6qtnxd_!3m7!1s0x395fc5dbd5bffceb:0x44c6621103b1075a!8m2!3d22.2679331!4d73.1882056!9m1!1b1!16s%2Fg%2F11g6qtnxd_?entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoASAFQAw%3D%3D" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-beauty-rose hover:text-beauty-pink transition-colors"
                >
                  See all Google Reviews
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
